import React from 'react';
import ChartWithAnnotations from './ChartWithAnnotations';

class StackedBarChartWithAnnotations extends React.Component {
    render(){
        return <ChartWithAnnotations chartType="stacked" {...this.props} />    
    }
}

export default StackedBarChartWithAnnotations